@if (vpImage.src && imageWidth) {
	<vp-image
		[className]="className"
		[editableInStoryblok]="_editable"
		[image]="vpImage"
	/>
}
